import { useContext, useEffect } from "react";
import { SOCKET_EVENTS, SocketContext } from "../components/SocketProvider";
import Game from "../store/Game";
import useCurrentUserData from "./useCurrentUserData";

export default function useAllInsightEvents() {
  const { socket } = useContext(SocketContext);
  const { getUserData } = useCurrentUserData();

  const onAllInsightEventsReq = (response) => {
    console.log('📊 Получены insight events данные:', response);
    const user = getUserData();
    if (
      user &&
      response.data.allGamesInsightEventData &&
      response.data.allGamesInsightEventData.length
    ) {
      const isUserMessage = response.data.allGamesInsightEventData.some(
        (el) => el.userId === user.id
      );
      if (
        user &&
        isUserMessage
        // response.data.currentGameInsightEventData &&
        // response.data.currentGameInsightEventData.userId === user.id
      ) {
        console.log('✅ Обновляем Game.insightEvents:', response.data.allGamesInsightEventData);
        Game.setInsightEventsData(response.data);
      }
    }
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.INSIGHT_EVENTS_DATA, onAllInsightEventsReq);
    return () => {
      socket.current.off(
        SOCKET_EVENTS.INSIGHT_EVENTS_DATA,
        onAllInsightEventsReq
      );
    };
  }, [socket]);
}
